import { Button } from '@maas-components/core'
import { useNavigate } from 'react-router-dom'
import Result from 'components/Result'

const NotFound: React.FC = () => {
  const routerNavigate = useNavigate()

  const handleGoHome = (): void => routerNavigate('/')

  return (
    <Result
      status="404"
      title="Página não encontrada"
      subtitle="Não conseguimos encontrar a página que você estava procurando."
    >
      <Button onClick={handleGoHome} variant="contained">
        Voltar a página inicial
      </Button>
    </Result>
  )
}

export default NotFound
